import { Routes } from '@angular/router';

import { PublicationComponent } from './publication/publication.component';

export const routes: Routes = [
  { path: 'publication/:id', component: PublicationComponent },
  { path: '', redirectTo: 'publication/', pathMatch: 'full' },
  { path: '**', redirectTo: 'publication/', pathMatch: 'full' }
];
